import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedParameter = () => {
  return {};
};

// TODO : ! MAIN_PARAMETERS bakılması gerekiyor mc da onaya göndermede vs. bu olmayabilir !
export default {
  state: () => ({
    selectedParameter: getDefaultSelectedParameter(),
    systemDateNow: new Date(),
    timeBetweenSystemAndLocalTime: 0,
  }),

  mutations: {
    setSelectedParameter(state, parameter) {
      Vue.set(state, "selectedParameter", parameter);
    },
    setSystemDateNow(state, systemDateNow) {
      Vue.set(state, "systemDateNow", systemDateNow);
    },
    setDefaultSelectedParameter(state) {
      Vue.set(state, "selectedParameter", getDefaultSelectedParameter());
    },
    setTimeBetweenSystemAndLocalTime(state, timeBetweenSystemAndLocalTime) {
      Vue.set(state, "timeBetweenSystemAndLocalTime", timeBetweenSystemAndLocalTime);
    },
    setDefaultParameterModule(state) {
      Vue.set(state, "selectedParameter", getDefaultSelectedParameter());
      Vue.set(state, "systemDateNow", new Date());
      Vue.set(state, "timeBetweenSystemAndLocalTime", 0);
    },
  },
  actions: {
    //TODO: load, update, create
    createParameter: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/parameters-main-services", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadParameters: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/parameters-main-services/entity").then((response) => {
        return response.data;
      });
    },
    loadPublishedParameters: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/parameters-main-services/entity/published").then((response) => {
        //TODO: Loader koyulacak
        return response.data;
      });
    },
    loadParameter: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/parameters-main-services/entity/" + request.id).then((response) => {
        return response.data;
      });
    },
    loadParameterHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/parameters-main-services/entity/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },
    loadSelectedParameterHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/parameters-main-services/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    // Parametre Yönetimi > Geçmiş sekmesi. Sunucu taraflı sayfalama;
    // params: { page, size, includeTotal, startDate?, endDate? }
    loadParameterIntentHistory: (context, params) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/parameters-main-services/intent-history", { params })
        .then((response) => response.data);
    },
    deleteParameter: (context, parameter) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/parameters-main-services/entity/" + parameter.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          parameter.intents = intents;
          parameter.intentId = response.data.id;
          return parameter;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftParameter: (context, parameter) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/parameters-main-services/draft/" + parameter.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishParameter: (context, parameter) => {
      return axios.get(context.getters.getMcServiceUrl + "/parameters-main-services/publish/" + parameter.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectParameter: (context, parameter) => {
      return axios.get(context.getters.getMcServiceUrl + "/parameters-main-services/reject/" + parameter.intentId).then((response) => {
        if (parameter.intents[0].type === "DELETE_MAIN_PARAMETERS") {
          parameter.intents = null;
          parameter.intentId = 0;
        } else if (parameter.intents[0].type === "CREATE_MAIN_PARAMETERS") {
          parameter.intents[0].status = "DRAFT";
        } else if (parameter.intents[0].type === "UPDATE_MAIN_PARAMETERS") {
          parameter.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    sendToApprovalParameter: (context, parameter) => {
      return axios.get(context.getters.getMcServiceUrl + "/parameters-main-services/sendToApproval/" + parameter.intentId).then((response) => {
        if (parameter.intents[0].type === "CREATE_MAIN_PARAMETERS") {
          parameter.intents[0].status = "WAITING_APPROVAL";
        } else if (parameter.intents[0].type === "UPDATE_MAIN_PARAMETERS") {
          parameter.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallParameter: (context, parameter) => {
      return axios.get(context.getters.getMcServiceUrl + "/parameters-main-services/recall/" + parameter.intentId).then((response) => {
        helper.recallOrRejectEntity(parameter, "MAIN_PARAMETERS");
        return response.data;
      });
    },
    cancelParameter: (context, parameter) => {
      return axios.get(context.getters.getMcServiceUrl + "/parameters-main-services/cancel/" + parameter.intentId).then((response) => {
        return response.data;
      });
    },
    getRegionalTrainValidTimeParameter(context) {
      return axios.get(context.getters.getTmsServiceUrl + "/train/regional-train-ticket-valid-time").then((response) => {
        return response.data;
      });
    },
    loadSystemDateNow(context) {
      return axios.get(context.getters.getTmsServiceUrl + "/inventory/now").then((response) => {
        context.commit(
          "setTimeBetweenSystemAndLocalTime",
          new Date(new Date(response.data).setHours(new Date(response.data).getHours() + 3)).getTime() - new Date()
        );
        context.commit("setSystemDateNow", new Date(new Date(response.data).setHours(new Date(response.data).getHours() + 3)));
        return response.data;
      });
    },
    loadGeneralOtherRoundingDigit(context) {
      return axios.get(context.getters.getMcServiceUrl + "/parameters/general-other-rounding-digit").then((response) => {
        return response.data;
      });
    },
    // Bugün geçerli olan tüm parametreleri düz liste olarak döner.
    // Aranan değer parametersValueList içindeki code ile bulunur (ParameterGeneralValueEnum kodları).
    loadCurrentDateParameters(context) {
      return axios.get(context.getters.getMcServiceUrl + "/parameters-main-services/get-current-date-parameters").then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedParameter: (state) => {
      return state.selectedParameter;
    },
    getSystemDateNow: (state) => {
      return state.systemDateNow;
    },
    getTimeBetweenSystemAndLocalTime: (state) => {
      return state.timeBetweenSystemAndLocalTime;
    },
  },
};
